module.exports = __webpack_public_path__ + "img/opcao-de-rotacao.9dd9c85b.png";